import { TipoAnexoContaEnum } from "core/features/conta/typings";

export const getTitleAnexoFromTipo = (tipoAnexo: TipoAnexoContaEnum) => {
  if (tipoAnexo === TipoAnexoContaEnum.DocumentoPagamento) {
    return "Doc. Pagamento";
  }
  if (tipoAnexo === TipoAnexoContaEnum.DocumentoFiscal) {
    return "Doc. Fiscal";
  }
  if (tipoAnexo === TipoAnexoContaEnum.Comprovante) {
    return "Comprovante";
  }

  if (tipoAnexo === TipoAnexoContaEnum.Outros) {
    return "Outros";
  }

  if (tipoAnexo === TipoAnexoContaEnum.DocumentoAcessorio) {
    return "Doc. Acessório";
  }

  return "Documento";
};
